import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { ArrowBack as ArrowBackIcon } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import Button from "../waybee-ui/Button";

const BackButton = ({ to, onClick }) => {
  const { t } = useTranslation();
  const hasTo = typeof to === "string" && to.length > 0;

  return (
    <Grid item sm={12}>
      <Button
        color="default"
        startIcon={<ArrowBackIcon />}
        size="large"
        {...(hasTo ? { component: Link, to } : {})}
        onClick={onClick}
      >
        {t("common.actions.back")}
      </Button>
    </Grid>
  );
};

BackButton.propTypes = {
  to: PropTypes.string,
  onClick: PropTypes.func
};

BackButton.defaultProps = {
  to: undefined,
  onClick: undefined
};

export default BackButton;
